<template>
    <div class="download page-container">
        <v-page-header
            title="下载中心"
            caption="系统仅保留最近一年的导出下载记录"
        />
        <div class="download-header">
            <span class="download-header-search">
                <v-input
                    v-model="searchValue"
                    @search="filterList"
                    @enter="filterList"
                    name="product"
                    kind="search"
                    placeholder="搜索"
                    style="width:200px;"
                />
            </span>
            <span class="download-header-import">
                <span class="download-header-tip">导出模块</span>
                <v-select
                    :options="importOptions"
                    v-model="selectModule"
                    @change="filterList"
                    max-height="unset"
                    placeholder="全部模块"
                />
            </span>
            <span class="download-header-date">
                <span class="download-header-tip">时间范围</span>
                <v-date-picker
                    v-model="selectDate"
                    :min-date="366"
                    :max-date="0"
                    @confirm="confirmDate"
                    @clear="clear"
                    enable-timer
                    clearable
                />
            </span>
            <span class="download-header-status">
                <span class="download-header-tip">状态</span>
                <v-select
                    :options="statusOptions"
                    v-model="selectStatus"
                    @change="filterList"
                    placeholder="全部"
                />
            </span>
        </div>
        <v-table
            :data="options"
            :header-fix="true"
            @paginationChange="paginationChange"
            :loading="loading"
            fixed-row-height
            class="download-table"
        >
            <v-table-column
                v-for="column in columns"
                :key="column.label"
                :column-key="column.columnKey"
                :label="column.label"
                :align="column.align"
                :sortable="column.sortable"
                :sort-order="column.sortOrder"
                :formatter="column.formatter"
                :class="column.class"
                :width="column.width"
            />
            <v-table-column
                column-key="operator"
                label="操作人"
                align="left"
                width="180"
            >
                <div
                    slot="cell"

                    slot-scope="props"
                    column="total"
                >
                    <span>
                        {{ `${props.row.kfext}(${props.row.kfext === props.row.kfuin ? '管理员' : '员工工号'})` }}
                    </span>
                </div>
            </v-table-column>
            <v-table-column
                column-key="total"
                label="数据量"
                align="right"
                width="160"
                sortable
            >
                <div
                    slot="cell"

                    slot-scope="props"
                    column="total"
                >
                    <span>
                        {{ toComma(props.row.total) }}
                    </span>
                </div>
            </v-table-column>
            <v-table-column
                key="status"
                column-key="status"
                label="状态"
                width="160"
            >
                <div
                    slot="cell"

                    slot-scope="props"
                    column="status"
                >
                    <p v-if="props.row.status === 1">
                        <v-tag
                            type="status"
                            kind="success"
                            status-text="成功"
                        />
                    </p>
                    <p v-else-if="props.row.status === 4">
                        <v-tag
                            type="status"
                            kind="warning"
                            status-text="任务终止"
                        />
                    </p>
                    <p v-else-if="props.row.status === 2">
                        <v-tag
                            type="status"
                            kind="danger"
                            status-text="失败"
                        />
                    </p>
                    <p v-else-if="props.row.status === 3 || props.row.status === 0">
                        <v-tag
                            type="status"
                            kind="info"
                            status-text="导出中"
                        />
                    </p>
                </div>
            </v-table-column>
            <v-table-column
                column-key="type_name"
                label="模块"
                width="200"
            >
                <div
                    slot="cell"

                    slot-scope="props"
                    column="type_name"
                >
                    <span>
                        {{ props.row.type_name }}
                    </span>
                </div>
            </v-table-column>
            <v-table-column
                column-key="operation"
            >
                <div
                    slot="cell"
                    slot-scope="props"
                >
                    <v-button-group>
                        <v-button
                            @click="readDetail(props.row.detail_url)"
                            type="link"
                            kind="primary"
                        >
                            查看数据
                        </v-button>
                        <v-button
                            v-if="props.row.status === 1"
                            @click="downloadFile(props.row.task_id)"
                            type="link"
                            kind="primary"
                        >
                            下载文件
                        </v-button>
                        <v-button
                            v-if="(props.row.status === 2 || props.row.status === 4) && props.row.download_type === 1"
                            @click="retryExport(props.row.task_id)"
                            type="link"
                            kind="primary"
                        >
                            再次导出
                        </v-button>
                        <v-button
                            v-if="props.row.status === 3 && props.row.download_type === 1"
                            @click="cancelTask(props.row.task_id)"
                            type="link"
                            kind="primary"
                        >
                            终止任务
                        </v-button>
                        <v-button
                            v-if="props.row.status === 2"
                            v-popconfirm="`errorRes-${props.row.task_id}`"
                            type="link"
                            kind="primary"
                        >
                            失败原因
                        </v-button>
                        <v-popconfirm
                            :ref="`errorRes-${props.row.task_id}`"
                            :use-arrow="false"
                            :footerConfig="{
                                cancel: {
                                    text: '知道了',
                                }
                            }"
                            placement="bottom-end"
                            title="失败原因"
                        >
                            <div class="demo-popconfirm-first">
                                {{ props.row.detail }}
                            </div>
                        </v-popconfirm>
                    </v-button-group>
                </div>
            </v-table-column>
        </v-table>
        <v-pagination
            v-show="total"
            :total="total"
            :index="page"
            :count="pageSize"
            :count-options="pagination.countOptions"
            @change="paginationChange"
        />
    </div>
</template>

<script>
import { toTimeString } from 'src/utils/formatDate';
import { toComma } from 'src/utils/numberTool';
import moment from 'moment';
export default {
    components: {
    },
    data() {
        return {
            toComma,
            toTimeString,
            selectStatus: -1,
            selectModule: 0,
            searchValue: '',
            options: [],
            loading: false,
            pagination: {
                showQuick: true,
                countOptions: [10, 15, 30, 50],
                defaultPageSize: 10,
            },
            importOptions: [],
            statusOptions: [
                {
                    value: -1,
                    text: '全部',
                    disabled: '',
                },
                {
                    value: 1,
                    text: '成功',
                    disabled: '',
                },
                {
                    value: 2,
                    text: '失败',
                    disabled: '',
                },
                {
                    value: 3,
                    text: '导出中',
                    disabled: '',
                },
                {
                    value: 4,
                    text: '任务终止',
                    disabled: '',
                },
            ],
            selectDate: [],
            columns: [
                {
                    label: '任务名称',
                    sortable: false,
                    align: 'left',
                    columnKey: 'name',
                    class: 'v-table-content',
                },
                {
                    label: '导出时间',
                    sortable: true,
                    align: 'left',
                    columnKey: 'update_time',
                    sortOrder: '',
                    formatter(value) {
                        return toTimeString(value);
                    },
                    width: 180,
                },
            ],
            page: 1,
            pageSize: 10,
            total: 0,
            startTime: 0,
            endTime: 0,
        };
    },
    watch: {
    },
    created() {
        const searchName = (window.location.search).match(/name=([\s\S]*)/) || [];
        this.searchValue =  searchName.length ? decodeURIComponent(searchName[1]) : '';
        this.fetchModuleList();
        this.fetchList();
    },
    mounted() {
    },
    methods: {
        filterList() {
            this.page = 1;
            this.fetchList();
        },
        fetchModuleList() {
            this.$ajax.gatewayPost('/v1/dl/task_type').then((res) => {
                if (res && res.code === 0) {
                    const moduleList = (res.data && res.data.records) || [];
                    this.importOptions.push({
                        value: 0,
                        text: '全部',
                    });
                    moduleList && moduleList.forEach((item) => {
                        this.importOptions.push({
                            value: item.type_id,
                            text: item.type_name,
                        });
                    });
                } else {
                    this.$message.error(res.msg || '拉取导出模块信息失败');
                }
            });
        },
        fetchList() {
            this.loading = true;
            const params = {
                offset: this.page - 1,
                limit: this.pageSize,
                name: this.searchValue,
                type: this.selectModule,
                status: this.selectStatus,
                start_time: this.startTime / 1000,
                end_time: this.endTime / 1000,
            };
            this.$ajax.gatewayPost('/v1/dl/list', params).then((res) => {
                if (res && res.code === 0) {
                    this.total = parseInt(res.data && res.data.total) || 0;
                    this.loading = false;
                    this.options = (res.data && res.data.records) || [];
                } else {
                    this.$message.error(res.message || '获取列表失败');
                }
            })
                .catch((err) => {
                    this.$message.error(err.message || '获取列表失败');
                });
        },
        paginationChange(current, pageSize) {
            this.page = current;
            this.pageSize = pageSize;
            this.fetchList();
        },
        readDetail(url) {
            if (url.length) window.open(url);
        },
        confirmDate(val) {
            if (val.length) {
                this.startTime = moment(val[0]).valueOf();
                this.endTime =  moment(val[1]).valueOf();
            }
            this.filterList();
        },
        clear() {
            this.startTime = 0;
            this.endTime = 0;
            this.fetchList();
        },
        cancelTask(id) {
            this.$ajax.gatewayPost('/v1/dl/cancel', { task_id: id }).then((res) => {
                if (res && res.code === 0) {
                    this.$message.success('终止任务成功');
                    this.fetchList();
                } else {
                    this.$message.error(res.message || '终止任务失败');
                }
            })
                .catch((err) => {
                    this.$message.error(err.message || '终止任务失败');
                });
        },
        retryExport(id) {
            this.$ajax.gatewayPost('/v1/dl/retry', { task_id: id }).then((res) => {
                if (res && res.code === 0) {
                    this.$message.success('再次导出成功');
                    this.fetchList();
                } else {
                    this.$message.error(res.message || '无法再次导出');
                }
            })
                .catch((err) => {
                    this.$message.error(err.message || '无法再次导出');
                });
        },
        downloadFile(id) {
            this.$ajax.gatewayPost('/v1/dl/download', { task_id: id }).then((res) => {
                if (res && res.code === 0) {
                    window.open(res.data && res.data.url);
                } else {
                    this.$message.error(res.message || '无法下载文件');
                }
            })
                .catch((err) => {
                    this.$message.error(err.message || '无法下载文件');
                });
        },

    },
};
</script>
<style lang="less">
@import './style.less';
</style>
